/**
 * @desc 删除驾驶员信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.IdParameter): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/mall/driver/deleteDriverInfo',
    params: data,
    method: 'get',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
